import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../api/client";

export function PageviewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    api("/analytics/event", { method: "POST", json: { type: "pageview", path: pathname } }).catch(
      () => {},
    );
  }, [pathname]);
  return null;
}
